import { utcToZonedTime, format } from 'date-fns-tz';
export const stateToTzMap = {
    AL: 'America/Chicago',
    AK: 'America/Anchorage', // Aleutians are America/Adak
    AS: 'Pacific/Pago_Pago',
    AZ: 'America/Phoenix', // no DST
    AR: 'America/Chicago',
    CA: 'America/Los_Angeles',
    CO: 'America/Denver',
    CT: 'America/New_York',
    DE: 'America/New_York',
    DC: 'America/New_York',
    FM: 'Pacific/Chuuk', // FSM spans Chuuk/Pohnpei/Kosrae; see notes
    FL: 'America/New_York', // Panhandle west of Apalachicola is Central
    GA: 'America/New_York',
    GU: 'Pacific/Guam',
    HI: 'Pacific/Honolulu',
    ID: 'America/Boise', // North Idaho is Pacific (see notes)
    IL: 'America/Chicago',
    IN: 'America/Indiana/Indianapolis', // Some counties are Central
    IA: 'America/Chicago',
    KS: 'America/Chicago', // Some western counties are Mountain
    KY: 'America/New_York', // Western KY is Central
    LA: 'America/Chicago',
    ME: 'America/New_York',
    MH: 'Pacific/Majuro', // Kwajalein also UTC+12
    MD: 'America/New_York',
    MA: 'America/New_York',
    MI: 'America/Detroit', // Western UP has Central
    MN: 'America/Chicago',
    MS: 'America/Chicago',
    MO: 'America/Chicago',
    MT: 'America/Denver',
    NE: 'America/Chicago', // Western NE is Mountain
    NV: 'America/Los_Angeles', // (West Wendover observes Mountain socially)
    NH: 'America/New_York',
    NJ: 'America/New_York',
    NM: 'America/Denver',
    NY: 'America/New_York',
    NC: 'America/New_York',
    ND: 'America/Chicago', // SW ND is Mountain
    MP: 'Pacific/Saipan',
    OH: 'America/New_York',
    OK: 'America/Chicago',
    OR: 'America/Los_Angeles', // SE OR (Malheur/Harney parts) is Mountain
    PW: 'Pacific/Palau',
    PA: 'America/New_York',
    PR: 'America/Puerto_Rico',
    RI: 'America/New_York',
    SC: 'America/New_York',
    SD: 'America/Chicago', // West SD (incl. Rapid City) is Mountain
    TN: 'America/New_York', // Eastern TN is Eastern, Western TN is Central
    TX: 'America/Chicago', // El Paso & Hudspeth are Mountain
    UT: 'America/Denver',
    VT: 'America/New_York',
    VI: 'America/St_Thomas',
    VA: 'America/New_York',
    WA: 'America/Los_Angeles',
    WV: 'America/New_York',
    WI: 'America/Chicago',
    WY: 'America/Denver'
};
/**
 * Calculates if the current time is within calling hours.
 * Returns 1 if both conditions are met:
 * - Current time is between 9am-7pm Eastern Time
 * - Current time is between 8am-9pm in the state's local time
 * Otherwise returns 0
 *
 * @param state - Two-letter US state abbreviation
 * @returns 1 if within calling hours, 0 otherwise
 */
export function calculateDuringCallingHours(state) {
    try {
        if (!state) {
            return 0;
        }
        const now = new Date();
        // Check Eastern time (9am - 7pm ET) because this is the time when we have people available to make the calls
        // (it's not enough to just check the local time zone, because we need people on our side too)
        const easternTime = utcToZonedTime(now, 'America/New_York');
        const easternHour = parseInt(format(easternTime, 'H'), 10);
        const isWithinEasternHours = easternHour >= 9 && easternHour < 19;
        if (!isWithinEasternHours) {
            return 0;
        }
        // Check local time for the state (8am - 9pm local)
        const localTimeZone = stateToTzMap[state];
        if (!localTimeZone) {
            console.warn(`No timezone mapping found for state: ${state}`);
            return 0;
        }
        const localTime = utcToZonedTime(now, localTimeZone);
        const localHour = parseInt(format(localTime, 'H'), 10);
        const isWithinLocalHours = localHour >= 8 && localHour < 21;
        return isWithinLocalHours ? 1 : 0;
    }
    catch (error) {
        console.error('Error calculating duringCallingHours:', error);
        return 0;
    }
}
//# sourceMappingURL=index.js.map